import WhiteCard from "src/components/WhiteCard";
import { useGetPatientCouponsQuery } from "src/api/services/patientsApi";
import { Stack, Typography, Button } from "@mui/material";
import CreatePatientCouponModal from "../Modals/CreatePatientCouponModal";
import { useManageModal } from "src/hooks/useManageModal";
import BillingModel from "../BillingModel";
import { PatientCoupon } from "src/api/types";
import { useUpdatePatientCouponMutation } from "src/api/services/patientCouponApi";
import { useCallback } from "react";

interface Props1 {
  patientCoupon: PatientCoupon;
}

const PatientCouponView = ({ patientCoupon }: Props1) => {
  const [updateCoupon, { isLoading }] = useUpdatePatientCouponMutation();

  const handleUpdate = useCallback(() => {
    updateCoupon({
      id: patientCoupon.id,
      body: {
        redeemed: true,
        redeemed_at: new Date().toISOString(),
      },
    });
  }, [patientCoupon.id, updateCoupon]);

  return (
    <Stack
      justifyContent="space-between"
      alignItems="center"
      direction="row"
      gap={0.5}
      p={1}
      sx={{ border: "1px solid #000000", borderRadius: "5px" }}
    >
      <Stack direction="row" gap={1}>
        {patientCoupon.product != null ? (
          <>
            <Typography>{patientCoupon.product.name}</Typography>
            <BillingModel
              model={patientCoupon.product.billing_model}
              size="medium"
            />
          </>
        ) : null}
        <Typography>{`${patientCoupon.coupon.name} ($${patientCoupon.coupon.amount})`}</Typography>
      </Stack>
      <Button size="small" onClick={handleUpdate} loading={isLoading}>
        Mark redeemed
      </Button>
    </Stack>
  );
};

interface Props {
  patientId: number;
}

const PatientCoupons = ({ patientId }: Props) => {
  const { data = [] } = useGetPatientCouponsQuery({
    id: patientId,
    params: {
      redeemed: false,
    },
  });
  const [open, { handleClose, handleOpen }] = useManageModal();

  return (
    <>
      <WhiteCard gap={1} sx={{ overflowY: "auto" }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="subtitle2">PATIENT COUPONS</Typography>
          <Button
            variant="text"
            sx={{ alignSelf: "start" }}
            onClick={handleOpen}
          >
            {" "}
            + Create
          </Button>
        </Stack>
        {data.length === 0 ? (
          <Typography>Patient has no coupons at this time.</Typography>
        ) : (
          data.map((c) => <PatientCouponView patientCoupon={c} key={c.id} />)
        )}
      </WhiteCard>
      <CreatePatientCouponModal
        onClose={handleClose}
        open={open}
        patientId={patientId}
      />
    </>
  );
};

export default PatientCoupons;
